



















import Vue from 'vue';
import PlusIcon from '@/assets/img/icons/plus.svg';
import PencilIcon from '@/assets/img/icons/pencil.svg';
import OptionWidget from '@/vue-components/util/OptionWidget.vue';

export interface DreamListOptionsModalInterface extends Vue {
  show(): void;
  hide(): void;
  addDream(): void;
  editDreamList(): void;
}

export default Vue.component('DreamListOptionsModal', {
  name: 'DreamListOptionsModal',
  components: {
    PlusIcon,
    PencilIcon,
    OptionWidget,
  },
  props: {
    editMode: Boolean,
  },
  methods: {
    show(): void {
      this.$modal.show('deleteListOptionsModal');
    },
    hide(): void {
      this.$modal.hide('deleteListOptionsModal');
    },
    addDream(): void {
      console.log('Add dream');
      this.hide();
      this.$router.push('/dreams/add');
    },
    editDreamList(): void {
      console.log('Edit dream list');
      // this.editMode=true;
      this.$emit('update:editMode', true);
      console.log(this.editMode);
      this.hide();
    },
    showDreamList(): void {
      console.log('Edit dream list');
      // this.editMode=false;
      this.$emit('update:editMode', false);
      this.hide();
    },
    showCompletedDreams(): void {
      console.log('Show completed dreams');
      this.hide();
    }
  },
});
